var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSpeciality17(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;stroke:#707070;}.b{clip-path:url(#a);}.c{fill:none;stroke:#208ce1;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}.d{fill:#e2e8f3;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 50,
    height: 50,
    transform: "translate(-811 -8203)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "b",
    transform: "translate(811 8203)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.527 0.303)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M-807.365-8161.189s-1.191-7.947,4.352-10.185,7.457.813,8.658.4,3.193-1.991,6.66-1.922c1.407-1.785,1.977-2.919,3.638-3.457-.211-2.3-.793-2.962.172-4.267-2.163-3.3-2.3-2.233-2.475-4.876-2.3-.515-7.857-.169-10.947-8.854"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M-792.153-8196.206a7.5,7.5,0,0,0,6.38,4.833c2.163-4.772,8.832-7.325,15.619-1.819s9.175,19.868-2.289,28.466-21.981-.178-21.981-.178-3.209,1.084-5.547-.953-3.922,2.941-3.168,4.525"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M-793.41-8168.046c-1.077-.052,14.782,11.163,24.134-6.033-3.115.892-4.392,2.2-6.208,2.527-4.713.84-3.841-1.439-8.8,1.847C-790.742-8165.427-792.333-8167.994-793.41-8168.046Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeciality17);
export default __webpack_public_path__ + "static/media/speciality17.929f8d1beb444aaf423fb752b3fcdcfc.svg";
export { ForwardRef as ReactComponent };